import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { InputCreateReminderRule } from 'graphql-query-contracts';
import { createReminderRuleMutation } from 'graphql-queries';
import { Workflow } from 'application-types';
import { WorkflowActiveActionEnum } from 'constants-workflows';

export const useReminderRuleWorkflows = (channelId?: string) => {
  const [isLoading, setIsLoading] = useState(false);

  const [workflows, setWorkflows] = useState<Workflow[]>([]);

  const [createReminderRule, { loading: loadingCreateReminderRule }] =
    useMutation(createReminderRuleMutation);

  const handleCreateReminderRule = async (
    reminderRule: InputCreateReminderRule
  ) => {
    await createReminderRule({
      variables: {
        reminderRule,
      },
    });
  };

  const onAddWorkflow = async (workflowToAdd: Workflow) => {
    setWorkflows(prevWorkflows => [...prevWorkflows, workflowToAdd]);

    return workflowToAdd;
  };

  const onWorkflowsSave = async (allWorkflows: Workflow[]) => {
    try {
      setIsLoading(true);

      const promises = allWorkflows.map(workflow =>
        handleCreateReminderRule({
          action: workflow.action,
          target: workflow.target,
          order: workflow._order,
          name: workflow.name,
          triggerTiming: workflow.when,
          triggerTime: workflow.time,
          triggerStatuses: WorkflowActiveActionEnum,
          groupId: channelId,
          teamId: channelId,
        })
      );

      const results = await Promise.allSettled(promises);

      const failures = results.filter(
        (r): r is PromiseRejectedResult => r.status === 'rejected'
      );

      if (failures.length > 0) {
        console.error('Some reminder rules failed to create:', failures);

        return false;
      }

      return true;
    } catch (error) {
      console.error(error);
      setIsLoading(false);

      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    loading: isLoading || loadingCreateReminderRule,
    reminderRuleWorkflows: workflows,
    addReminderRuleWorkflow: onAddWorkflow,
    saveReminderRuleWorkflows: onWorkflowsSave,
  };
};
